import { convertUTCDateToLocalDate } from "go-core/components/Formatters/FormatDate";

export const getCreditCardExpirationDays = (licenseExpiresAt: string, organizationTimezone?: string) => {
	return (
		Math.floor(
			(convertUTCDateToLocalDate(licenseExpiresAt, organizationTimezone).getTime() - new Date().getTime()) /
				86400000
		) + 1
	);
};
